import React from 'react';

/**
 * SCD brand logo — Société de Commerce et de Distribution.
 * Utilise le logo officiel fourni par le client (/public/scd-logo.png,
 * fond blanc) dans un cercle pour s'intégrer au thème sombre.
 */
export default function SCDLogo({ size = 32, className = '', withGlow = true }) {
  return (
    <div
      className={`inline-flex items-center justify-center rounded-full overflow-hidden ${withGlow ? 'ring-2 ring-accent/30 shadow-[0_0_20px_-4px_rgba(59,130,246,0.4)]' : ''} bg-white ${className}`}
      style={{ width: size, height: size, flexShrink: 0 }}
      aria-label="SCD Game logo"
      data-testid="scd-logo"
    >
      <img
        src="/scd-logo.png"
        alt="SCD — Société de Commerce et de Distribution"
        width={size}
        height={size}
        className="w-full h-full object-contain"
        loading="eager"
        decoding="async"
      />
    </div>
  );
}
